import moment from 'moment';
import {
	PULL_ARCHIVE_ERROR,
	PULL_ARCHIVE_LOADING,
	PULL_ARCHIVE_SUCCESS,
} from '../types';
import EventService from '../../services/EventService';

let options = {
    timeZone: 'Etc/UTC',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  };


let formatter = new Intl.DateTimeFormat("en-US", options);

export const fetchData = (auth) => {
	return (dispatch) => {
		dispatch({
			type: PULL_ARCHIVE_LOADING,
		});

		if (auth.details.role === 'Administrador') {

			EventService.getPosibleDuplicateEvents_New().then(res =>{
				let data = [];
					//console.log(res);
					res.data.forEach((doc) => {
						const object = doc;
						object.doc = doc.event_id;
						
						if(object.fecha_evento !== null ){
							let dateValue = formatter.format(new Date(object.fecha_evento));
							// let dateValue = moment(object.fecha_evento).format('MM/DD/YYYY');
							// let month = moment(dateValue).format("M");
					        // let year = moment(dateValue, 'MM/DD/YYYY').year();
							// let day = moment(dateValue).date();
							// let str = month + '/' + day + '/' + year; 
							object.fecha = dateValue;
						}
						else{
							object.fecha = moment(
							object.fecha_evento_old,
							'DD [de] MMMM [de] YYYY'
						).format('MM/DD/YYYY');
						}
						data = [...data, object];
					});

					dispatch({
						type: PULL_ARCHIVE_SUCCESS,
						payload: data,
					});
				}).catch((error) => {
					dispatch({
						type: PULL_ARCHIVE_ERROR,
						payload: error,
					});
					EventService.logError({ message: error.message, stack: error.stack });
				});


		} else {
		
			EventService.getPosibleDuplicateEvents_New().then(res => {
				let data = [];
				//console.log(res);
				res.forEach((doc) => {
					const object = doc.data();
					object.doc = doc.id;
					object.fecha = moment(
						object.fecha_evento,
						'MM/DD/YYYY'
						//'DD [de] MMMM [de] YYYY'
					).format('YYYYMMDD');
					data = [...data, object];
				});

				dispatch({
					type: PULL_ARCHIVE_SUCCESS,
					payload: data,
				});
			}).catch((error) => {
				dispatch({
					type: PULL_ARCHIVE_ERROR,
					payload: error,
				});
				EventService.logError({ message: error.message, stack: error.stack });
			});

		}
	};
};


